angular
	.module('app')
	.component('portalList', {
		templateUrl: 'modules/selection/pages/portalList.html',
		controller: PortalList
	});

function PortalList() {}